import React, { useState, useEffect, useCallback } from "react";
import { API_BASE_URL } from "../config";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Loader from "../components/loader";
import "./prescriptions-list.css";

const PrescriptionsList = () => {
  const [prescriptionListData, setPrescriptionListData] = useState([]);
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [loading, setLoading] = useState(true); // Main loading state
  const navigate = useNavigate();
  const session = JSON.parse(sessionStorage.getItem("user"));
  let sessionUserId = session?.payLoad.user.Id || null;

  // Fetch prescriptions when the page changes
  useEffect(() => {
    if (sessionUserId) {
      const fetchData = async () => {
        // Set loadingMore to true only when fetching more data (not on the initial load)
        if (page === 1) {
          setLoading(true); // Show loading spinner when the first page is loading
        } else {
          setLoadingMore(true); // Show "loading more" spinner when fetching additional data
        }

        try {
          const response = await fetch(
            `${API_BASE_URL}/prescription/list?patient_profile_id=${sessionUserId}&page=${page}&perPage=20`
          );
          if (!response.ok) throw new Error("Network response was not ok");

          const data = await response.json();

          if (data.payLoad.length === 0) {
            setAllDataLoaded(true); // Mark all data as loaded
            return;
          }

          // Update prescription list data (if it's the first page, replace the list, otherwise append data)
          setPrescriptionListData((prev) =>
            page === 1 ? data.payLoad : [...prev, ...data.payLoad]
          );
          setPage((prev) => prev + 1); // Increment the page for the next fetch
        } catch (error) {
          console.error("Error fetching prescriptions:", error);
        } finally {
          // Stop loading state after the data is fetched
          setLoading(false);
          setLoadingMore(false); // Stop "loading more" state after fetching more data
        }
      };

      fetchData();
    }
  }, [sessionUserId, page]);

  // Handle scroll and load more data when the user reaches the bottom
  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + window.scrollY >= document.body.scrollHeight - 10 && // A small offset for edge cases
      !loadingMore && // Prevent multiple fetches if already loading more
      !allDataLoaded // Don't fetch if all data is loaded
    ) {
      setPage((prevPage) => prevPage + 1); // Trigger next page load
    }
  }, [loadingMore, allDataLoaded]);

  // Add scroll event listener
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  const onAudioVideoCallClick = useCallback(
    (id) => {
      navigate(`/prescription/${id}`);
    },
    [navigate]
  );

  return (
    <>
      <Navbar />{" "}
      <Container fluid>
        <div className="row">
          <div className="col-md-12 text-center">
            {/* <h2>Prescriptions</h2> */}
          </div>
        </div>
        <div>
          <Row className="mt-4">
            {loading ? (
              <Loader type="prescription" count={3} />
            ) : prescriptionListData.length > 0 ? (
              prescriptionListData.map((value) => (
                <Col xs={12} md={6} lg={4} key={value.Id} className="mb-4">
                  <Card className="prescription-card">
                    <Card.Body>
                      <Row>
                        <Col xs={4} md={4} lg={4} className="d-flex align-items-center">
                          <div className="doctor-info flex flex-column align-items-center">
                            <img
                              src={value.DoctorImage || ""}
                            />
                            <span className="text-styling-one ms-2">
                              {value.DoctorFullName
                                ? value.DoctorFullName.charAt(0).toUpperCase() +
                                  value.DoctorFullName.slice(1)
                                : "N/A"}
                            </span>
                          </div>
                        </Col>
                        <Col xs={8} md={8} lg={8} className="">
                          <span className="consultation-title">
                            <strong>Complaint: </strong>
                            {value.Complaint || "N/A"}
                          </span>
                          <span className="complaint-text">
                            <div className="">
                              <strong>Date: </strong>
                              {value.ConsultationDate || "N/A"}
                            </div>
                          </span>
                          <span className="complaint-text">
                            <div className="">
                              <strong>Diagnosis: </strong>
                              {value.Diagnosis || "N/A"}
                            </div>
                          </span>
                          <Button
                            variant="secondary"
                            onClick={() => onAudioVideoCallClick(value.Id)}
                            className="mt-3  btn-sm"
                          >
                            View Details
                          </Button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <Col xs={12}>
                <div className="no-data-message">
                  <p>There is no data.</p>
                </div>
              </Col>
            )}
          </Row>

          {loadingMore && page > 1 && (
            <Col xs={12} className="text-center">
              <Spinner animation="border" />
            </Col>
          )}

          {/* {!loadingMore && !allDataLoaded && (
            <p className="text-center">No more prescriptions.</p>
          )} */}
        </div>
      </Container>
      <div style={{ paddingTop: "250px" }}>
        <Footer />
      </div>
    </>
  );
};

export default PrescriptionsList;
